const envConfig = {
	BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
};

export default envConfig;
